export default __webpack_public_path__ + "dist/img/step-4.png";